<template>
  <div
    :class="{ required: data.required }"
    class="field">
    <label>{{ $t(data.label) }}</label>
    <quill-editor
      v-model="input"
      :options="options"/>
  </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'QuillEditor',
  components: {
    quillEditor
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      validator: (value) => {
        return (value === null || ['string', 'number', 'undefined'].includes(typeof value))
      },
      required: true
    }
  },
  data () {
    return {
      input: this.value,
      options: {
        modules: {
          toolbar: [
            ['bold', 'italic'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link']
          ]
        },
        placeholder: this.$t(this.data.placeholder)
      }
    }
  },
  watch: {
    input (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style scoped>

</style>
